import React from "react";
import { ResourceStrings } from "../../ResourceStrings";
import { Icon } from "@fluentui/react/lib/Icon";
import styled from "styled-components/macro";

export default function Secured(): JSX.Element {
    return (<Wrapper>
        <Icon iconName="LockSolid" />
        <span>{ResourceStrings.secured()}</span>
    </Wrapper>);
}

const Wrapper = styled.span`
    span {
        font-size: 1.4rem;
        line-height: 2.4rem;
        font-weight: 600;
    }

    i {
        padding-right: .5rem;
        font-size: 1.6rem;
        color: var(--color-surface-dark2);
    }
`;
